import { render, staticRenderFns } from "./BookingDialog.vue?vue&type=template&id=dfa488c6&scoped=true&"
import script from "./BookingDialog.vue?vue&type=script&lang=js&"
export * from "./BookingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa488c6",
  null
  
)

export default component.exports